import { prisma } from "client";

export const createDeviceToken = async ({
  token,
  userId,
  eventId,
}: {
  token: string;
  userId: string;
  eventId: string;
}) => {
  try {
    return await prisma.deviceToken.upsert({
      where: {
        token_eventId: {
          token,
          eventId,
        },
      },
      update: {
        userId,
        eventId,
      },
      create: {
        token,
        userId,
        eventId,
      },
    });
  } catch (error) {
    console.error("Error creating/updating device token:", error);
    throw new Error("Failed to create/update device token");
  }
};

export const getDeviceTokenByToken = async (token: string, eventId: string) => {
  return await prisma.deviceToken.findUnique({
    where: {
      token_eventId: {
        token,
        eventId,
      },
    },
    include: {
      user: true,
      event: true,
    },
  });
};

export const getDeviceTokensByUser = async (
  userId: string,
  eventId?: string
) => {
  const deviceTokens = await prisma.deviceToken.findMany({
    where: {
      userId,
      ...(eventId && { eventId }),
    },
    select: {
      token: true,
    },
  });
  return deviceTokens.map((deviceToken) => deviceToken.token);
};

export const deleteDeviceToken = async (token: string, eventId: string) => {
  return await prisma.deviceToken.delete({
    where: {
      token_eventId: {
        token,
        eventId,
      },
    },
  });
};

export const deleteAllDeviceTokensForUser = async (
  userId: string,
  eventId?: string,
  token?: string
) => {
  return await prisma.deviceToken.deleteMany({
    where: {
      userId,
      ...(eventId && { eventId }),
      ...(token && { token }),
    },
  });
};
